// @ts-nocheck
// import { ApiHandlerDiscreteParameter } from "@insite/client-framework/HandlerCreator";
import {
    Cart,
    CartResult,
    UpdateCartApiParameter,
    updateCartWithResult,
} from "@insite/client-framework/Services/CartService";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    Handler,
} from "@toolkit/Modules/client-framework/HandlerCreator";

// type HandlerType = Handler<{ requestOutOfCycleOrder: boolean; cart: Cart }>;

type CartRequestOutOfCycleParameter = {
    requestOutOfCycleOrder: boolean;
    cart: Cart;
};

type HandlerType = ApiHandlerDiscreteParameter<CartRequestOutOfCycleParameter, UpdateCartApiParameter, CartResult>;

export const DispatchSetRequestOutOfCycle: HandlerType = props => {
    props.dispatch({
        type: "store/Pages/Cart/SetRequestOutOfCycle",
        requestOutOfCycleOrder: props.parameter.requestOutOfCycleOrder,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        cart: {
            ...props.parameter.cart,
            properties: {
                ...props.parameter.cart.properties,
                addOutOfCycleToOrder: props.parameter.requestOutOfCycleOrder.toString(),
            },
        },
    };
};

export const UpdateCart: HandlerType = async props => {
    const result = await updateCartWithResult(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        return false;
    }
};

export const LoadCart: HandlerType = props => {
    props.dispatch(loadCurrentCart({ shouldLoadFullCart: false }));
};

export const chain = [DispatchSetRequestOutOfCycle, PopulateApiParameter, UpdateCart, LoadCart];

const setRequestOutOfCycle = createHandlerChainRunner(chain, "SetRequestOutOfCycle");
export default setRequestOutOfCycle;
